/**
 * Copyright © 2024 Delicious AI, LLC
 */

import convert from 'heic-convert/browser'

type Props = {
  inputFile: File
  outputFormat: 'JPEG' | 'PNG'
  quality?: number
}

export const convertHEIC = async (props: Props) => {
  const { inputFile, outputFormat, quality = 0.92 } = props
  const formatOptions = {
    format: outputFormat, // output format
    ...(outputFormat === 'JPEG' ? { quality } : {}), // the jpeg compression quality, between 0 and 1
  }
  const buffer = new Uint8Array(
    await inputFile.arrayBuffer(),
  ) as unknown as ArrayBuffer
  const outputBuffer = await convert({
    buffer, // this must be Unit8Array https://github.com/catdad-experiments/heic-convert/issues/34
    ...formatOptions,
  })

  const fileType = outputFormat === 'JPEG' ? 'image/jpeg' : 'image/png'
  const blob = new Blob([outputBuffer], { type: fileType })
  const file = new File([blob], 'converted_image.jpeg', {
    type: blob.type,
  })

  return file
}
